import { ICardProps } from '../components/pages/FavoritesPage/components/Card/Card';
import Cookies from 'react-cookies';
import { addFavoritesApi } from '../api/favorites/addFavorites';
import { removeFavoritesApi } from '../api/favorites/removeFavorites';
import { getFavoritesData } from '../api/favorites/getFavorites';
import { bulkAddFavoritesApi } from '../api/favorites/bulkAddFavorites';

export interface IResData {
  docs: {
    item: ICardProps;
    type: 'product' | 'part' | 'accessory';
    itemId: string;
  }[];
  totalDocs: number;
  limit: number;
  totalPages: number;
  page: number;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  prevPage?: any;
  nextPage?: any;
}

const getFavorites = async (): Promise<ICardProps[]> => {
  if (!Cookies.load('isUser')) {
    let favorites: ICardProps[] = [];
    const favoritesString = localStorage.getItem('favorites');
    if (favoritesString) favorites = JSON.parse(favoritesString);
    return favorites;
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const res = await getFavoritesData(Cookies.load('payload-token') || null, {
      limit: 999,
    });
    if (res && res.docs)
      return res.docs.map((item) => {
        return { ...item.item, type: item.type, id: item.itemId };
      });
    else return [];
  }
};

const getFavoritesFull = async (
  limit?: number,
  page?: number,
): Promise<IResData | null> => {
  if (!Cookies.load('isUser')) {
    return null;
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const res = await getFavoritesData(Cookies.load('payload-token') || null, {
      limit: limit || 20,
      page: page || 1,
    });
    if (res && res.docs) return res;
    else return null;
  }
};

const updateFavorites = async (item: ICardProps, action: 'delete' | 'add') => {
  if (!Cookies.load('isUser')) {
    let favorites = await getFavorites();
    if (action === 'add') {
      favorites.push(item);
      localStorage.setItem('favorites', JSON.stringify(favorites));
    } else {
      localStorage.setItem(
        'favorites',
        JSON.stringify(favorites.filter((i) => i.id !== item.id)),
      );
    }
  } else {
    if (action === 'add') {
      addFavoritesApi(Cookies.load('payload-token') || null, {
        id: item.id,
        type: item.type,
      });
    } else {
      removeFavoritesApi(Cookies.load('payload-token') || null, {
        id: item.id,
        type: item.type,
      });
    }
  }
};

const removeFavoritesLocalStorage = () => {
  localStorage.removeItem('favorites');
};

const saveFavoritesFromLocalStorage = async () => {
  let favorites: ICardProps[] = [];
  const favoritesString = localStorage.getItem('favorites');
  if (favoritesString) favorites = JSON.parse(favoritesString);
  bulkAddFavoritesApi(Cookies.load('payload-token') || null, {
    items: favorites.map((item) => {
      return { id: item.id, type: item.type };
    }),
  })
    .then(() => removeFavoritesLocalStorage())
    .catch(() => removeFavoritesLocalStorage());
};

export {
  updateFavorites,
  getFavorites,
  removeFavoritesLocalStorage,
  saveFavoritesFromLocalStorage,
  getFavoritesFull,
};
